var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import { createUIElement } from "../../helpers";
import { StackView, STACK_GAP, STACK_ALIGN } from "../../StackView";
import { Button, BUTTON_VIEW } from "../../Button";
import { TextInput } from "../TextInput";
import { InputControl } from "../helpers/InputControl";
import { CopyIcon } from './icons';
import { Icon, ICON_SIZES } from "../../Icon";
var StyledTextInput = styled(TextInput)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", "\n\n    ", " {\n        ", "\n    }\n"], ["\n    ",
    "\n\n    ", " {\n        ",
    "\n    }\n"])), function (_a) {
    var isFocused = _a.isFocused, disabled = _a.disabled, theme = _a.theme;
    return isFocused &&
        !disabled && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n            border: 1px solid ", ";\n        "], ["\n            border: 1px solid ", ";\n        "])), theme.colorControlBorderAccent);
}, InputControl.selector, function (_a) {
    var disabled = _a.disabled, theme = _a.theme;
    return !disabled && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n                background-color: ", ";\n            "], ["\n                background-color: ", ";\n            "])), theme.colorBackgroundBlank);
});
export var CopyInput = createUIElement('CopyInput', function (_a, ref) {
    var className = _a.className, _b = _a.disabled, disabled = _b === void 0 ? false : _b, value = _a.value, _c = _a.buttonText, buttonText = _c === void 0 ? 'Copy' : _c, _d = _a.icon, icon = _d === void 0 ? React.createElement(CopyIcon, null) : _d, size = _a.size, onFocus = _a.onFocus, onBlur = _a.onBlur, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, onKeyPress = _a.onKeyPress, style = _a.style, rest = __rest(_a, ["className", "disabled", "value", "buttonText", "icon", "size", "onFocus", "onBlur", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    var _e = useState(false), isFocused = _e[0], setIsFocused = _e[1];
    var copyToClipboard = function () { return __awaiter(void 0, void 0, void 0, function () {
        var e_1, text, textarea;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!value) {
                        return [2 /*return*/];
                    }
                    if (!(typeof navigator !== 'undefined' &&
                        typeof ((_a = navigator === null || navigator === void 0 ? void 0 : navigator.clipboard) === null || _a === void 0 ? void 0 : _a.writeText) === 'function')) return [3 /*break*/, 5];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, navigator.clipboard.writeText(value)];
                case 2:
                    _b.sent();
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _b.sent();
                    console.error(e_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
                case 5:
                    text = value;
                    textarea = document.createElement('textarea');
                    textarea.textContent = text;
                    textarea.style.position = 'fixed'; // Prevent scrolling to bottom of page in MS Edge.
                    document.body.appendChild(textarea);
                    textarea.select();
                    try {
                        document.execCommand('copy'); // Security exception may be thrown by some browsers.
                    }
                    catch (e) {
                        console.error(e);
                    }
                    finally {
                        document.body.removeChild(textarea);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement(StackView, __assign({}, rest, { "data-selector-id": rest['data-selector-id'], className: "vm-CopyInput " + className, align: STACK_ALIGN.center, gap: STACK_GAP.m, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: ref, style: style }),
        React.createElement(StyledTextInput, { "data-selector-id": "copy-input-control", disabled: disabled, size: size, value: value, readOnly: true, isFocused: isFocused, onFocus: function (e) {
                setIsFocused(true);
                onFocus === null || onFocus === void 0 ? void 0 : onFocus(e);
            }, onBlur: function (e) {
                setIsFocused(false);
                onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
            } }),
        React.createElement(Button, { "data-selector-id": "copy-input-button", ui: BUTTON_VIEW.text, disabled: disabled, onClick: copyToClipboard },
            React.createElement(Icon, { size: ICON_SIZES.m, src: icon }),
            buttonText)));
});
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=CopyInput.js.map